// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogSlider_wrapper__Sn10b","slide":"BlogSlider_slide__t_1rI","card":"BlogSlider_card__C6mxk"};